import { apiRequest } from './client';
import type { OnboardingResult } from './types';

export const onboarding = {
  complete: (installationId: number, setupAction?: string, state?: string) =>
    apiRequest<OnboardingResult>('/api/onboarding/complete', {
      method: 'POST',
      body: { installationId, setupAction, state },
    }),
};
